import { _js } from '@ifixit/localize';
import {
   Menu,
   MenuButton,
   MenuList,
   MenuItem,
   Text,
   IconButton,
   Tooltip,
   HStack,
} from '@chakra-ui/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faParagraph, faChevronDown } from '@fortawesome/pro-solid-svg-icons';
import { tiptapButtonStyle } from './TiptapButton';
import { useEditorContext } from '../editor_context';

const DropdownItem = (props: any) => (
   <MenuItem height={16} {...props}>
      {props.children}
   </MenuItem>
);

export const TextStyleDropdown = () => {
   const { editor } = useEditorContext();

   const headerStyle = {
      fontSize: '4xl',
      fontWeight: 700,
      color: 'gray.900',
   };

   const subheaderStyle = {
      fontSize: '2xl',
      fontWeight: 600,
      color: 'gray.600',
   };

   const paragraphStyle = {
      fontSize: 'md',
   };

   return (
      <Menu onClose={() => setTimeout(() => editor.commands.focus(), 50)}>
         <Tooltip placement="top-start" label={_js('Text style')}>
            <MenuButton
               as={IconButton}
               icon={
                  <HStack spacing="7px">
                     <FontAwesomeIcon icon={faParagraph} />
                     <FontAwesomeIcon icon={faChevronDown} />
                  </HStack>
               }
               padding={1}
               {...tiptapButtonStyle}
            />
         </Tooltip>
         <MenuList padding={0}>
            <DropdownItem
               isDisabled={editor.isActive('heading', { level: 2 })}
               onClick={() => editor.chain().setHeading({ level: 2 }).run()}
            >
               <Text {...headerStyle}>
                  {
                     /* Translators: "header" as in the text at the top of a page */
                     _js('Header')
                  }
               </Text>
            </DropdownItem>
            <DropdownItem
               isDisabled={editor.isActive('heading', { level: 3 })}
               onClick={() => editor.chain().setHeading({ level: 3 }).run()}
            >
               <Text {...subheaderStyle}>
                  {
                     /* Translators: "subheader" as in a secondary header on the top of a page */
                     _js('Subheader')
                  }
               </Text>
            </DropdownItem>
            <DropdownItem
               isDisabled={editor.isActive('paragraph')}
               onClick={() => editor.chain().setParagraph().run()}
            >
               <Text {...paragraphStyle}>
                  {
                     /* Translators: "paragraph" as in regular text */
                     _js('Paragraph')
                  }
               </Text>
            </DropdownItem>
         </MenuList>
      </Menu>
   );
};
